import { Injectable } from '@angular/core';
import { ReservationService } from '../reservation/reservation.service';
import { QuoteService } from './quote.service';
import { DriverInformation, Reservation } from '../reservation/reservation';
import { QuoteStatus } from './insurance-status.enum';

@Injectable({
  providedIn: 'root'
})
export class InsuranceService {
  private reservation: Reservation;
  private allowedContries: string[] = ['US'];
  private notAllowedStates: string[] = [];
  private currentStateCode: string;

  constructor(
    private reservationService: ReservationService,
    private quoteService: QuoteService
  ) { }

  public init() {
    this.reservationService.hasChanged$.subscribe(() => {
      const newStateCode = this.getDriverInfo() && this.getDriverInfo().stateCode;

      if (!this.currentStateCode || !newStateCode || this.currentStateCode !== newStateCode) {  
        this.setReservationData();
        this.setQuoteStatusInvalidIfNotAllowedCountryOrState()
        this.resetQuoteDataIfInvalid();
        this.currentStateCode = newStateCode;

        if (this.isDriverInfoValid()) {
          this.quoteService.setLoadingStatus();
          this.quoteService.makeQuoteRequest();
        }
      }
    }) 
  }

  public getQuoteStatus(): QuoteStatus  {
    return this.quoteService.getQuoteStatus();
  }

  public getQuoteDailyPrice(): number {
    return this.quoteService.getDailyPrice();
  }

  public getQuotePrice(): number {
    return this.quoteService.getQuotePrice();
  }

  private setReservationData() {
    this.reservation = this.reservationService.reservation;
  }

  public isDriverInfoValid(): boolean {
    return this.isDriverInfoStateSet() && this.isAllowedCountry() && this.isAllowedState();
  }

  public resetService():void {
    this.quoteService.clearQuote();
    this.currentStateCode = undefined;
  }

  private isDriverInfoStateSet(): boolean {
    return this.getDriverInfo().stateCode !== undefined;
  }

  public isAllowedCountry(): boolean {
    var selectedCountry = this.getDriverInfo().countryCode
    return this.allowedContries.includes(selectedCountry);
  }

  public showInvalidCountry(): boolean {
    return this.isNotAllowedCountry();
  }

  private isAllowedState(): boolean {
    var selectedState: string = this.getDriverInfo().stateCode;
    return !this.notAllowedStates.includes(selectedState);
  }

  public isNotAllowedCountry(): boolean {
    var selectedCountry = this.getDriverInfo().countryCode;
    if (selectedCountry === undefined || selectedCountry.length == 0) return false;
    return !this.allowedContries.includes(selectedCountry);
  }

  public showInvalidState(): boolean {
    return this.isNotAllowedState();
  }

  public isNotAllowedState(): boolean {
    var selectedState: string = this.getDriverInfo().stateCode;
    if (selectedState === undefined || selectedState.length == 0) return false;
    return this.notAllowedStates.includes(selectedState);
  }

  private getDriverInfo(): DriverInformation {
    return this.reservation && this.reservation.driverInformation
  }

  private setQuoteStatusInvalidIfNotAllowedCountryOrState(){
    if (this.isNotAllowedCountry() || this.isNotAllowedState()) {
      this.quoteService.setInvalidStatus();
    }
  }

  private resetQuoteDataIfInvalid(){
    if (this.quoteService.getQuoteStatus() === QuoteStatus.Invalid){
      this.quoteService.resetQuote();
    }
  }

  public getDailyPrice(): number {
    return this.quoteService.getDailyPrice();
  }
}
